import { z } from "zod";

/**
 * Wire-shape schema for `stripe.getPublishableKey`. Single source of truth
 * — the trpc procedure imports this for `.output(...)` and the client
 * durable-cache layer imports it as the parse target.
 */
export const publishableKeyWireSchema = z.object({
  publishableKey: z.string(),
});

export type PublishableKey = z.infer<typeof publishableKeyWireSchema>;
